import { useState, useEffect } from "react";
import React from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import CloseIcon from '@mui/icons-material/Close';
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import brandStyles from "../Brand/Brand.module.css";
import styles from "./TransactionPage.module.css"
import "../../components/mcrbTableTheme.css";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import { toast } from "react-toastify";
import "../../index.css";
import * as XLSX from 'xlsx';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const { apiEndpoint } = config;

const Mstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    maxWidth: "560px",
    borderRadius: "16px",
    bgcolor: 'background.paper',
    border: 'none',
    outline: 'none',
    boxShadow: '0 20px 50px rgba(43, 22, 87, 0.24)',
    p: 0,
    overflow: 'hidden',
    '@media (max-width: 600px)': {
        width: '92%',
    },
};

const Transction = () => {
    const decoded: any = tokenDecode();
    const [transactionList, setTransactionList] = useState([]);
    const [stransactionList, setStransactionList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDetailsLoading, setIsDetailsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [Fopen, setFOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleFOpen = () => setFOpen(true);
    const handleFClose = () => setFOpen(false);
    const [Msgopen, setMsgOpen] = useState(false);
    const [tcsValue, settcsValue] = useState(0);
    const handleClose = () => {
        setOpen(false); setCalculation({
            "order_id": "",
            "sellerapp_commission": "",
            "ondc_commission": "",
            "buyer_commission": "",
            "seller_amount": "",
            "order_total": "",
            "tds_deduction": "",
            "tcs_deduction": "",
            "receive_status": 0,
            "settlement_status": "",
            "buyer_commission_percentage": "",
            "gst_on_buyer_commission": "",
            "ONDC_Commissions": "",
            "seller_np_amount": "",
            "seller_np_amount_gst": ""
        })
        settdsValue(0);
        settcsValue(0);
        setsettleClicked(false);
        setTransactionid("");
        setTransactionidDate("");
        setalltransactions([]);
        allTransactionlist();
    };
    const [calculation, setCalculation] = useState({
        "order_id": "",
        "sellerapp_commission": "",
        "ondc_commission": "",
        "buyer_commission": "",
        "seller_amount": "",
        "order_total": "",
        "tds_deduction": "",
        "tcs_deduction": "",
        "receive_status": 0,
        "settlement_status": "",
        "buyer_commission_percentage": "",
        "gst_on_buyer_commission": "",
        "ONDC_Commissions": "",
        "seller_np_amount": "",
        "seller_np_amount_gst": ""
    })
    const [SelectionParam, setSelectionParam]: any = useState(false)
    const [Transactionid, setTransactionid]: any = useState("");
    const { data } = decoded;
    const rawData = {
        seller_id: ''
    }
    const [searchData, setSearchData]: any = useState(rawData);
    const { permission: { seller, } } = data;
    const [sellerList, setSellerList] = useState([]);
    const [valueid, setValueid] = useState("");
    const [valueamount, setValueamount] = useState("");
    const [valuedate, setValuedate] = useState("");
    const [alltransactionData, setalltransactionData] = useState([]);
    const [alltransactions, setalltransactions] = useState([])
    const [TransactionidDate, setTransactionidDate]: any = useState("");
    const [settleClicked, setsettleClicked] = useState(false);
    const [tdsValue, settdsValue] = useState(0);
    var count = 1;
    const [selectedBox, setselectedBox]: any = useState([]);
    const [filterDaata, setfilterDaata] = useState({
        seller_id: "",
        startDate: "",
        endDate: ""
    })
    interface State extends SnackbarOrigin {
        sopen: boolean;
    }
    const [state, setState] = useState<State>({
        sopen: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, sopen } = state;
    const handleClick = (newState: SnackbarOrigin) => {

        setState({ ...newState, sopen: true });
    };
    useEffect(() => {
        // console.log(selectedBox)
        if (selectedBox.length > 0) {
            handleClick({ vertical: 'top', horizontal: 'center' })
        }
    }, [selectedBox])

    const fetchSellerList = async () => {
        let apiendpoint;
        if (decoded?.data?.user?.seller_id === 1) {
            apiendpoint = "transactionStatus"
        } else {
            apiendpoint = "transactionStatus"
        }
        setIsLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/${apiendpoint}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    settlement_status: 1
                }
            });
            // console.log("transaction data -> ", data);
            if (data.status === 200) {
                setIsLoading(false);
                setTransactionList(data.data);
                setalltransactionData(data.data)

            }
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    }
    const getTransaction = async (order_id: any) => {
        try {
            setIsDetailsLoading(true)
            setCalculation({ ...calculation, order_id });
            const { data } = await axios({
                url: `${apiEndpoint}/getcalculationNew`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    order_id
                }
            });
            // console.log("calculation detail ->------   ", data);
            // console.log("okss", data.data.seller_amount.toFixed(2));

            setCalculation({
                order_id,
                "sellerapp_commission": parseFloat(data.data[0].sellerapp_commission).toFixed(2),
                "ondc_commission": parseFloat(data.data[0].ondc_commission).toFixed(2),
                "buyer_commission": parseFloat(data.data[0].buyer_commission).toFixed(2),
                "seller_amount": parseFloat(data.data[0].seller_amount).toFixed(2),
                "order_total": parseInt(data.data[0].order_total).toFixed(2),
                "tds_deduction": parseInt(data.data[0].tcs_deduction).toFixed(2),
                "tcs_deduction": parseInt(data.data[0].tds_deduction).toFixed(2),
                "receive_status": data.data[0].receive_status,
                "settlement_status": data.data[0].settlement_status,
                "buyer_commission_percentage": data.data[0].buyer_commission_percentage,
                "gst_on_buyer_commission": data.data[0].gst_on_buyer_commission,
                "ONDC_Commissions": data.data[0].ONDC_Commissions,
                "seller_np_amount": data.data[0].seller_np_amount,
                "seller_np_amount_gst": data.data[0].seller_np_amount_gst

            });

            settcsValue(parseInt(data.data[0].tcs_deduction))
            settdsValue(parseInt(data.data[0].tds_deduction))
            setIsDetailsLoading(false)
        } catch (error) {
            toast.error("Something Went Wrong!")
            setIsDetailsLoading(false)
        }
    }
    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        setValueid("");
        setValueamount("");
        setValuedate("");
        var optionvalue = e.target.value;
        if (optionvalue) {
            try {

                const {
                    seller_id
                } = searchData;
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filtertransactiondataall`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        seller_id: optionvalue
                    }

                });
                if (data.status === 200) {
                    // console.log(data.response);
                    setTransactionList(data.response);
                    setStransactionList(data.response);
                }


            } catch (error) {
                console.log("error", error);
            }
        }
        else {
            setTransactionList(stransactionList);
        }
    };

    const inputeHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {
                const {
                    seller_id
                } = searchData;
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filtertransactionsellerdata`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        seller_id: { searchData },
                        order_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data);
                    setTransactionList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };


    const handlesClose = () => {
        setState({ ...state, sopen: false });
    };

    function checkHandler(row: any) {
        // console.log("row---->", row)
        // console.log("dhadha", row.order_id);
        let hasId = selectedBox.some((item: any) => item == row.order_id)
        if (!hasId) {
            setselectedBox((prev: any) => {
                return [...prev, row.order_id]
            })
        } else {
            setselectedBox((prev: any) => {
                return prev.filter((item: any) => item !== row.order_id)
            })
        }

    }

    // console.log("selectedBox----->", selectedBox)
    const COLUMNS = [
        !SelectionParam ? {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        } : {
            Header: "Select",
            Footer: "Select",
            accessor: (row: any) => {
                return <input type="checkbox" onChange={() => checkHandler(row)} checked={selectedBox.includes(row.order_id)} />

            },
            disableFilters: true,
            sticky: "left",

        },
        {
            Header: "Order ID",
            Footer: "Order ID",
            accessor: "order_id",
            sticky: "left"
        },
        {
            Header: "Seller Name",
            Footer: "Seller Name",
            accessor: "company_name",
            sticky: "left"
        },
        {
            Header: "Total Amount (in Rs)",
            Footer: "Total Amount (in Rs)",
            accessor: (a: any) => parseInt(a.order_total).toFixed(2),
            sticky: "left"
        },
        {
            Header: "Buyer Commission (in Rs)",
            Footer: "Buyer Commission (in Rs)",
            accessor: (a: any) => { let roundedNumber = Math.round(parseFloat(a?.buyer_amt) * 1000) / 1000; return roundedNumber },
            sticky: "left"
        },
        {
            id: "settlestatus",
            Header: "Settle Status",
            Footer: "Settle Status",
            accessor: (a: any) => (
                <span className={`${styles.pillBase} ${a.settlement_status == "1" ? styles.pillGreen : styles.pillGrey}`}>
                    {a.settlement_status == "1" ? "Settled" : "Not Settled"}
                </span>
            ),
            sticky: "left"
        },
        {
            id: "Transaction id",
            Header: "Transaction id",
            Footer: "Transaction id",
            accessor: (a: any) => a.transaction_id,
            sticky: "left"
        },
        {
            Header: "Created Date",
            Footer: "Created Date",
            accessor: "created_at",
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <span className={brandStyles.iconBtn} onClick={() => { getTransaction(row.order_id); handleOpen() }}>
                        <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" />
                    </span>
                )
            },
            sticky: "left"
        },

    ];
    count++

    useEffect(() => {
        getSellerList();
        allTransactionlist();
        // if (decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) {
        //     setMsgOpen(true)
        // }

        if (decoded?.data?.user?.seller_id === 1) {
            getallsettledtransactions()
        }

        if (decoded?.data?.user?.seller_id > 1) {
            fetchSellerList()
        }

    }, [])

    async function getallsettledtransactions() {
        setIsLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/get_transactions_list_settled`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    settlement_status: 0
                }
            });
            // console.log("transaction data -> ", data);
            if (data.status === 200) {
                setTransactionList(data?.data);
                setStransactionList(data?.data);
                setalltransactionData(data?.data);
                setIsLoading(false);
            }
        } catch (error) {
            console.log("error", error);

            setIsLoading(false);
        }
    }


    function OrderidSearchHandler(e: any) {
        if (e.target.value == "") {
            if (decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) {
                // getFilteredData()
                getallsettledtransactions();
                setfilterDaata((prev) => {
                    return { ...prev, seller_id: "" }
                })
            } else {
                fetchSellerList()
            }

        } else {
            setTransactionList(alltransactionData.filter((item: any) => item.order_id.includes(e.target.value)))
        }

    }

    // console.log("alltransactionData", alltransactionData)

    function filterChangeHandler(e: any) {
        setfilterDaata((prev) => {
            return {
                ...prev, [e.target.name]: e.target.value
            }
        })
    }

    async function getFilteredData() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondataall`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    ...filterDaata
                }

            });
            if (data.status === 200) {
                // console.log(data.response);
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }

            handleFClose()


        } catch (error) {
            handleFClose()
            console.log("error", error);
        }

    }

    const allTransactionlist = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/exporttransaction`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    seller_id: decoded?.data?.user?.seller_id,
                    settlement_status: 1,
                }
            });
            // console.log("order data -> ", data);
            if (data.status === 200) {

                setalltransactions(data.data)
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const exportToExcel = (orders: any) => {

        const headers = [
            'S.No', "Order Id", "Seller Name", "Order Total", "Seller Amount", "Buyer Commission", "Settlement", "TDS", "TCS", "Settled Date", "Order Date"
        ];

        const settledOrders = orders.filter((order: any) => !!order?.settled_date);

        const data = settledOrders.map((order: any, index: any) => {

            // let orderCreatedDate = moment(order?.created_at).format("DD-MM-YYYY hh:mm:ss")
            // let sellerName = order?.address?.start?.location?.descriptor?.name
            // let sellerEmail = order?.address?.end?.contact?.email
            // let sellerContact = order?.address?.end?.contact?.phone
            return {
                'S.No': index + 1,
                "Order Id": order?.order_id,
                "Seller Name": order.company_name,
                "Order Total": order?.order_total,
                "Seller Amount": order?.seller_amount,
                "Buyer Commission": order?.buyer_amt,
                "Settlement": order?.settlement,
                "TDS": order?.tds,
                "TCS": order?.tcs,
                "Settled Date": order?.settled_date,
                "Order Date": order?.order_date
            }
        });

        // // Create a new workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });

        // // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');

        // // Generate a unique name for the Excel file (you can customize this as needed)
        const fileName = `transactions_${new Date().getTime()}.xlsx`;

        // // Export the workbook as an Excel file
        XLSX.writeFile(wb, fileName);
    };

    async function clearSelectionHandler() {
        setSelectionParam(false)
        setselectedBox([])
        handlesClose()

    }

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        // Add leading zero if month or day is a single digit
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    async function submitCheckedDataSingle() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/sss`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    transaction_id: Transactionid,
                    settlement_status: 1,
                    settlement_date: TransactionidDate
                },
            })

            if (data.status == 200) {

                if (data.status === 200) {
                    toast.success("Settled Successfully!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    clearSelectionHandler()
                }
            } else {
                toast.error("Error in Setteling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

    }

    const action = (
        <div className={styles.bulkBar}>
            <input type="text" className={styles.bulkInput} placeholder="Transaction ID.." onChange={(e) => { setTransactionid(e.target.value) }} />

            <input type="date" className={styles.bulkInput} max={getCurrentDate()} onChange={(e) => { setTransactionidDate(e.target.value) }} />

            <button className={styles.bulkSettleBtn} disabled={((Transactionid === "") || (TransactionidDate === "")) ? true : false}
                onClick={submitCheckedDatatoOn}
            >
                Settle
            </button>
            <span className={styles.bulkClose} onClick={clearSelectionHandler}>
                <CloseIcon fontSize="small" />
            </span>
        </div>
    );

    async function submitCheckedDatatoOn() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update_settlementssss`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                method: "POST",
                data: {
                    order_id: [...selectedBox],
                    transaction_id: Transactionid,
                    settlement_status: 1,
                    settlement_date: TransactionidDate
                },
            })

            if (data.status == 200) {

                if (data.status === 200) {
                    toast.success("Settled Successfully!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    clearSelectionHandler()
                }
            } else {
                toast.error("Error in Setteling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

    }

    function inactiveProductHandler() {
        // console.log(productList)
        let z = transactionList.filter(item => item)
        // console.log(z);
        let m = z.map((item: any) => item?.order_id)
        setselectedBox(m)
        // checkHandler(...m)
    }

    const preventMinus = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    async function receiveHandler() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/sss`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    tds: tdsValue,
                    status: 1
                },
            })

            if (data.status == 200) {

                if (data.status === 200) {
                    toast.success("Received Successfully!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    clearSelectionHandler()
                }
            } else {
                toast.error("Error in Receiving!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleMsgClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setMsgOpen(false);
    };

    async function selectSellerHandler(e: any) {
        setfilterDaata((prev) => {
            return { ...prev, seller_id: e.target.value }
        })
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondataall`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    seller_id: e.target.value
                }

            });
            if (data.status === 200) {
                // console.log(data.response);
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }

            handleFClose()


        } catch (error) {
            handleFClose()
            console.log("error", error);
        }
    }


    function calculateGST(originalValue: any, gstRate: number) {
        let z = parseInt(originalValue)
        return (z * gstRate) / 100;
    }
    // console.log("selectedBox------>", selectedBox)


    return (
        <>
            <ThemeMaker>
                <div className={`${styles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>Settled Transactions</span>
                        </div>

                        <div className={styles.toolbarRow}>
                            <input type="search" name="order_id" placeholder="Search by Order ID" className={styles.searchInput} onChange={(e: any) => OrderidSearchHandler(e)} />

                            {(decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) ? (
                                <select name="seller_id" id=""
                                    onChange={(e) => { selectSellerHandler(e) }}
                                    className={styles.sellerSelect}
                                    value={filterDaata.seller_id}
                                >
                                    <option value="" disabled>Select Seller</option>
                                    {sellerList.map((item: any) => (
                                        <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name}</option>
                                    ))}
                                </select>
                            ) : null}

                            <div className={styles.spacer} />

                            <button
                                type="button"
                                className={styles.exportBtn}
                                disabled={alltransactions.length === 0}
                                onClick={() =>
                                    alltransactions.length !== 0 &&
                                    setTimeout(() => {
                                        exportToExcel(alltransactions);
                                    }, 2000)
                                }
                            >
                                <DownloadRoundedIcon style={{ fontSize: 18 }} />
                                Export Transactions
                            </button>
                        </div>

                        <div className={styles.editToggleRow}>
                            <div className={styles.editToggle}>
                                {SelectionParam ? (
                                    <>
                                        <button type="button" className={styles.pillToggleBtn} onClick={clearSelectionHandler}>Cancel</button>
                                        <button type="button" className={styles.pillToggleBtn} onClick={inactiveProductHandler}>Select All</button>
                                    </>
                                ) : (
                                    <button type="button" className={`${styles.pillToggleBtn} d-none`} onClick={() => setSelectionParam(true)}>Edit</button>
                                )}
                            </div>
                        </div>

                        <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap} ${styles.desktopTable}`} style={{ minHeight: "60vh" }}>
                            {!isLoading ? <Paginated data={transactionList} columns={COLUMNS} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div>}
                        </div>

                        <div className={`${brandStyles.bodyArea} ${styles.mobileList}`}>
                            {transactionList.map((item: any, index: any) => {
                                return (
                                    <div className={styles.mobileCard} key={item?.order_id ?? index}>
                                        <div className={styles.mobileRow}>
                                            <span className={styles.mobileLabel}>Order ID</span>
                                            <span className={styles.mobileValue}>{item?.order_id}</span>
                                        </div>
                                        <div className={styles.mobileRow}>
                                            <span className={styles.mobileLabel}>Transaction ID</span>
                                            <span className={styles.mobileValue}>{item?.transaction_id}</span>
                                        </div>
                                        <div className={styles.mobileRow}>
                                            <span className={styles.mobileLabel}>Order Total</span>
                                            <span className={styles.mobileValue}>{item?.order_total}</span>
                                        </div>
                                        <div className={styles.mobileRow}>
                                            <span className={styles.mobileLabel}>Seller Name</span>
                                            <span className={styles.mobileValue}>{item?.company_name}</span>
                                        </div>
                                        <button type="button" className={styles.mobileViewBtn} onClick={() => { getTransaction(item.order_id); handleOpen() }}>
                                            <VisibilityOutlinedIcon fontSize="small" /> View
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={Mstyle} className={styles.modalBox}>
                        <div className={styles.modalHeader}>
                            <p className={styles.modalTitle}>Order ID: {calculation?.order_id}</p>
                            <span className={styles.modalClose}><CloseIcon onClick={() => handleClose()} /></span>
                        </div>
                        {!isDetailsLoading ? (
                            <>
                                <div className={styles.modalBody}>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>Order Amount</span>
                                        <span className={styles.detailValue}>&#8377; {calculation?.order_total}</span>
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>TDS Deduction</span>
                                        <input type="number" className={styles.detailInput} min={0} value={tdsValue} onKeyPress={preventMinus} onChange={(e: any) => settdsValue(e.target.value)} />
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>TCS Deduction</span>
                                        <input type="number" className={styles.detailInput} min={0} value={tcsValue} onKeyPress={preventMinus} onChange={(e: any) => settcsValue(e.target.value)} />
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>Buyer Commission ({calculation.buyer_commission_percentage}%)</span>
                                        <span className={styles.detailValue}>&#8377; {calculation.buyer_commission}</span>
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>GST On Buyer Commission (18%)</span>
                                        <span className={styles.detailValue}>&#8377; {(Math.round(parseFloat(calculation.gst_on_buyer_commission) * 100) / 100).toFixed(2)}</span>
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>Seller NP Commission ({calculation.ONDC_Commissions}%)</span>
                                        <span className={styles.detailValue}>&#8377; {(Math.round(parseFloat(calculation.seller_np_amount) * 100) / 100).toFixed(2)}</span>
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>GST on Seller NP amount</span>
                                        <span className={styles.detailValue}>&#8377; {(Math.round(parseFloat(calculation.seller_np_amount_gst) * 100) / 100).toFixed(2)}</span>
                                    </div>
                                    <div className={styles.detailRow}>
                                        <span className={styles.detailLabel}>Seller Amount</span>
                                        <span className={styles.detailValue}>&#8377; {calculation.seller_amount}</span>
                                    </div>
                                </div>

                                <div className={styles.modalFooter}>
                                    {!settleClicked ? (
                                        <>
                                            {calculation.receive_status !== 1 && <button className={styles.primaryBtn} onClick={receiveHandler}>Receive</button>}
                                            {calculation.settlement_status != "1" ? (
                                                <button className={styles.successBtn} onClick={() => { setsettleClicked(true) }}>Settle</button>
                                            ) : null}
                                        </>
                                    ) : null}

                                    {settleClicked ? (
                                        <>
                                            <input type="text" className={styles.footerInput} placeholder="Transaction ID" onChange={(e) => { setTransactionid(e.target.value) }} />
                                            <input type="date" className={styles.footerInput} max={getCurrentDate()} onChange={(e) => { setTransactionidDate(e.target.value) }} />
                                            <button className={styles.primaryBtn} disabled={((Transactionid === "") || (TransactionidDate === "")) ? true : false} onClick={submitCheckedDataSingle}>Submit</button>
                                        </>
                                    ) : null}
                                </div>
                            </>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}><CircularProgress /></div>
                        )}
                    </Box>
                </Modal>
                <Modal open={Fopen}
                    onClose={handleFClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">


                    <Box className={styles.simpleModalBox}>
                        <div className={styles.modalHeader}>
                            <p className={styles.modalTitle}>Filters</p>
                            <span className={styles.modalClose}><CloseIcon onClick={handleFClose} /></span>
                        </div>

                        <div className={styles.modalBody}>
                            {(decoded?.data?.user?.seller_id === 1 || decoded?.data?.user?.parent_id === 1) ? (
                                <div className={styles.field}>
                                    <span className={styles.label}>Seller</span>
                                    <select name="seller_id" id=""
                                        onChange={filterChangeHandler}
                                        className={brandStyles.input}
                                        value={filterDaata.seller_id}
                                    >
                                        <option value="">Select Seller</option>
                                        {sellerList.map((item: any) => (
                                            <option value={item?.seller_id} key={item?.seller_id}>{item?.name}</option>
                                        ))}
                                    </select>
                                </div>
                            ) : null}

                            <div className="d-flex" style={{ gap: "16px" }}>
                                <div className={styles.field} style={{ flex: 1 }}>
                                    <span className={styles.label}>Start Date</span>
                                    <input name="startDate" type="date" className={brandStyles.input} onChange={filterChangeHandler} value={filterDaata.startDate} />
                                </div>

                                <div className={styles.field} style={{ flex: 1 }}>
                                    <span className={styles.label}>End Date</span>
                                    <input name="endDate" type="date" onChange={filterChangeHandler} className={brandStyles.input} value={filterDaata.endDate} />
                                </div>
                            </div>
                        </div>

                        <div className={styles.modalFooter}>
                            <button className={styles.ghostBtn} onClick={() => { window.location.reload() }}>Clear Filter</button>
                            <button className={styles.primaryBtn} onClick={getFilteredData}>Apply Filter</button>
                        </div>
                    </Box>
                </Modal >

            </ThemeMaker >

            <div style={{ width: "25%" }}>
                {/* <Button onClick={handleClick}>Open simple snackbar</Button> */}
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={sopen}
                    sx={{ width: "100%" }}
                    // onClose={handleClose}
                    key={vertical + horizontal}
                    action={action}
                />
            </div>

            <Snackbar open={Msgopen} autoHideDuration={20000} onClose={handleMsgClose} key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleMsgClose} sx={{ width: '100%', padding: "30px", fontWeight: 600, background: "#105293", fontSize: "18px" }} >
                    To see transactions, Select a seller.
                </Alert>
            </Snackbar>
        </>
    )
}


export default Transction;
